<script lang="ts" generics="TValues">
    import { type Form } from '@jmvdevelop/svelte-form';
    import { fade } from 'svelte/transition';

    export let form: Form<TValues, string>;
    export let displayIfHasFieldsErrors = false;

    $: nbSubmits = form.stores().nbSubmits();
    $: hasRootErrors = form.stores().hasRootErrors();
    $: hasErrors = form.stores().hasFieldErrors();
    $: hasSubmitErrors = form.stores().hasSubmitErrors();
    $: rootErrors = form.stores().rootErrors();
    $: submitErrors = form.stores().submitErrors();
</script>

{#if $nbSubmits > 0 && ($hasRootErrors || $hasSubmitErrors || $hasErrors)}
    <div>
        {#if displayIfHasFieldsErrors && $hasErrors}
            <div
                class="bg-red-100 rounded-[4px] border border-red-400 text-red-800 p-4 shadow-leo my-4"
                in:fade
            >
                <div>
                    <p>Veuillez vérifier les champs marqués en rouge.</p>
                    <p>
                        Assurez-vous d'avoir correctement rempli toutes les informations
                        requises avant de soumettre le formulaire à nouveau.
                    </p>
                    <p>Merci.</p>
                </div>
            </div>
        {/if}

        {#if $hasRootErrors}
            <div
                class="bg-red-100 rounded-[4px] border border-red-400 text-red-800 p-4 shadow-leo my-4 flex flex-col gap-2"
                in:fade
            >
                {#each $rootErrors as error}
                    <p class="m-0 p-0">{error}</p>
                {/each}
            </div>
        {/if}

        {#if $hasSubmitErrors}
            <div
                class="bg-red-100 rounded-[4px] border border-red-400 text-red-800 p-4 shadow-leo my-4 flex flex-col gap-2"
                in:fade
            >
                {#each $submitErrors as error}
                    <p class="m-0 p-0">{error}</p>
                {/each}
            </div>
        {/if}
    </div>
{/if}
